import { Injectable } from '@angular/core';
import { ProjectFile } from '@portal-core/project-files/models/project-file.model';
import { ProjectFilesApiService } from '@portal-core/project-files/services/project-files-api.service';
import { ProjectFileTreeUpdate, ProjectFilesTreeDataProvider, TreeDataRequest } from '@portal-core/project-files/services/project-files-tree-data-provider';
import { Observable, of } from 'rxjs';

/**
 * Git-only data provider for the project files tree.
 * Fetches committed files from the .NET API with no workspace/collab merging.
 * This is the default provider used by ProjectFilesTreeComponent.
 */
@Injectable()
export class ProjectFilesDataProvider extends ProjectFilesTreeDataProvider {
  readonly fileUpdates$: Observable<ProjectFileTreeUpdate | null> = of(null);

  constructor(private projectFilesApiService: ProjectFilesApiService) {
    super();
  }

  getTree$(request: TreeDataRequest): Observable<ProjectFile[]> {
    return this.projectFilesApiService.getProjectFileTree$(
      request.projectId,
      request.branchName,
      request.treePath,
      request.includeFiles,
      request.fileFilter,
      false
    );
  }

  hasUncommittedDescendant(): boolean {
    return false;
  }

  dispose() { }
}
